import { useEffect } from "react";

import AISummaryContainer from "./components/Containers/AISummaryContainer";
import { useAISummaryStore } from "./store/aiSummaryStore";

export default function AISummary() {
  const { reset } = useAISummaryStore();

  useEffect(() => reset, [reset]);

  return (
    <div id="ai-summary-page-container" className="h-fit w-full p-2">
      <AISummaryContainer />
    </div>
  );
}
